export default function DetailSkeletonOneColumn() {
  return (
    <div className="w-full lg:w-10/12 max-w-screen-2xl mx-auto px-5 py-10 flex flex-col lg:flex-row gap-8">
      <div className="w-full space-y-3 py-5">
        <div className="h-6 w-1/4 bg-gray-200 rounded animate-pulse mb-8" />
        <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-11/12 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-10/12 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
      </div>
    </div>
  );
}
